import { BT_Acquisition_FTTC } from "./bt-acquisition-fttc-route"
import { BT_Acquisition_FTTP } from "./bt-acquisition-fttp-route"
import { BT_Retention_FTTC } from "./bt-retention-fttc-route"
import { BT_Retention_FTTP } from "./bt-retention-fttp-route"
import { Sky_Acquisition_FTTC } from "./sky-acquisition-fttc-route"
import { Sky_Acquisition_FTTP } from "./sky-acquisition-fttp-route"
import { Sky_Retention_FTTC } from "./sky-retention-fttc-route"
import { Sky_Retention_FTTP } from "./sky-retention-fttp-route"
import { Vodafone_Acquisition_FTTC } from "./vodafone-acquisition-fttc-route"
import { Vodafone_Acquisition_FTTP } from "./vodafone-acquisition-fttp-route"
import { Vodafone_Retention_FTTC } from "./vodafone-retention-fttc-route"
import { Vodafone_Retention_FTTP } from "./vodafone-retention-fttp-route"
import { Virgin_Acquisition } from "./virgin-acquisition-fttc-route"
import { Virgin_Retention } from "./virgin-retention-fttc-route"

const routes = [
  BT_Acquisition_FTTC,
  BT_Acquisition_FTTP,
  BT_Retention_FTTC,
  BT_Retention_FTTP,
  Sky_Acquisition_FTTC,
  Sky_Acquisition_FTTP,
  Sky_Retention_FTTC,
  Sky_Retention_FTTP,
  Vodafone_Acquisition_FTTC,
  Vodafone_Acquisition_FTTP,
  Vodafone_Retention_FTTC,
  Vodafone_Retention_FTTP,
  Virgin_Acquisition,
  Virgin_Retention
]

export default routes
